import { integrationsInitialized } from '@Actions/integrations.action';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const IntegrationsView = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(integrationsInitialized());
	}, []);

	return null;
};

export default IntegrationsView;
